<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet">
        <h1 i18n>Green Box Terms</h1>
    
        <h2 i18n>1. Introduction</h2>
        <p i18n>Welcome to the Green Box service (“Service”), provided by Listx OÜ (“Listx”). By using our Service, you agree to comply with and be bound by the following terms and conditions (“Terms”). Please review these Terms carefully before using the Service. If you do not agree with these Terms, you must not use the Service.</p>
        
        <h2 i18n>2. Service Description</h2>
        <p i18n>The Green Box service provides an easy way for users to sell their unused items. Users will receive a cardboard box, pack it with items they no longer need, and Listx will handle the sale process on their behalf. The Service includes delivery of the box, pick-up of the packed box, and the potential sale of the items within the box.</p>

        <h2 i18n>3. Eligibility</h2>
        <p>The Service is only available to residents of Tallinn, Estonia. By using this Service, you confirm that you are at least 18 years of age and have the legal capacity to enter into this agreement.</p>

        <h2 i18n>4. Ordering the Green Box</h2>
        <p>To participate, you must fill out the order form with your name, address, email, phone number. You must ensure that all information provided is accurate and up-to-date.</p>

        <h2 i18n>5. Packing and Item Conditions</h2>
        <p i18n>You agree to only pack items that are clean, functional, and have a potential resale value. Items should be complete and in good condition. The following items are not accepted:</p>
        <ul>
          <li i18n>Tableware and cutlery</li>
          <li i18n>Counterfeits, replicas, or bootlegs.</li>
          <li i18n>Used beauty products (e.g., makeup, sunscreen, oral and dental care items) unless they are in mint condition.</li>
          <li i18n>Items that are illegal, hazardous, or not suitable for resale.</li>
        </ul>
          
        <h2 i18n>6. Pick-Up and Delivery</h2>
        <p i18n>Once your box is packed, you can schedule a pick-up by using the contact details provided with the box. We will arrange for a free pick-up at your convenience. We can refuse to pick up the box if we deem the contents of the box to be not suitable for resale as per our terms.</p>

        <h2 i18n>7. Item Valuation and Sales</h2>
        <p i18n>After we receive your box, we will evaluate the items and send you a proposed sales price for each item. You have 48 hours to confirm or reject the proposed prices. If you do not respond within this period, the prices will be considered accepted.</p>
        <ul>
          <li i18n>Items will be listed for sale for a minimum of 8 weeks.</li>
          <li i18n>You will earn 50% of the sales value for items sold.</li>
          <li i18n>Payments will be transferred to your bank account weekly based on the sales proceeds.</li>
        </ul>

        <h2 i18n>8. Unsold Items</h2>
        <p i18n>If an item remains unsold after 8 weeks, you can choose to:</p>
        <ul>
          <li i18n>Keep the item listed for a longer period at our suggested reduced price.</li>
          <li i18n>Donate the item to a charity.</li>
          <li i18n>Have the item returned to you (shipping costs may apply).</li>
        </ul>
        <p i18n>If you do not make a selection within the specified time, the item will be donated to charity.</p>
        <p i18n>At any time, Listx reserves the right to return the items back to the owner and end the sale at it’s own discretion.</p>

        <h2 i18n>9. User Responsibilities</h2>
        <ul>
          <li i18n>You are responsible for ensuring that the items packed in the Green Box meet the conditions outlined above.</li>
          <li i18n>You must pack items securely to prevent damage during transit.</li>
          <li i18n>You are responsible for complying with all local laws regarding the sale and donation of items.</li>
        </ul>

        <h2 i18n>10. Listx Responsibilities</h2>
        <ul>
          <li i18n>Listx will handle the logistics of delivering the Green Box, picking up packed boxes, and listing items for sale.</li>
          <li i18n>We will manage the sales process, including photographing, pricing, and listing the items on appropriate platforms.</li>
          <li i18n>Listx will ensure that payments are transferred to your bank account as specified in these Terms.</li>
        </ul>
        
        <h2 i18n>11. Liability</h2>
        <ul>
          <li i18n>Listx is not liable for any loss or damage to items during transit unless such loss or damage is due to our negligence.</li>
          <li i18n>Listx is not responsible for any inaccuracies in item descriptions provided by you or for any misrepresentations regarding the condition of the items.</li>
          <li i18n>Listx total liability, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, arising under or in connection with these Terms shall be limited to the total amount payable to you under these Terms.</li>
        </ul>

        <h2 i18n>12. Termination</h2>
        <p i18n>Listx reserves the right to terminate or suspend your use of the Service if you violate these Terms or for any other reason at our sole discretion.</p>

        <h2 i18n>13. Amendments</h2>
        <p i18n>Listx may update or amend these Terms from time to time. The most current version of the Terms will be available on our website. By continuing to use the Service after any changes, you agree to be bound by the revised Terms.</p>

        <h2 i18n>14. Governing Law</h2>
        <p i18n>These Terms are governed by the laws of Estonia. Any disputes arising from or relating to these Terms shall be subject to the exclusive jurisdiction of the courts of Estonia.</p>

        <h2 i18n>15. Contact Information</h2>
        <p i18n>If you have any questions or concerns about these Terms, please contact us at support&#64;listx.ai or through our website at www.listx.ai.</p>
      
      </div>
    </div>
  </div>
</div>